"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextProvider = exports.ContextConsumer = void 0;
exports.useContexts = useContexts;
exports.connectContextsToProps = connectContextsToProps;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var React = __importStar(require("react"));
var Hoc_1 = require("./Hoc");
function renderConsumers(consumers, values, children) {
    if (consumers.length === 0) {
        return children.apply(void 0, __spreadArray([], __read(values), false));
    }
    var Consumer = consumers[0];
    return (0, jsx_runtime_1.jsx)(Consumer, { children: function (value) { return renderConsumers(consumers.slice(1), __spreadArray(__spreadArray([], __read(values), false), [value], false), children); } });
}
var ContextConsumer = /** @class */ (function (_super) {
    __extends(ContextConsumer, _super);
    function ContextConsumer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContextConsumer.prototype.render = function () {
        return renderConsumers(this.props.contexts.map(function (c) { return c.Consumer; }), [], this.props.children);
    };
    return ContextConsumer;
}(React.Component));
exports.ContextConsumer = ContextConsumer;
function useContexts() {
    var contexts = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        contexts[_i] = arguments[_i];
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- runs synchronously and deterministically
    return contexts.map(function (c) { return React.useContext(c); });
}
function renderProviders(providerValuePairs, children) {
    if (providerValuePairs.length === 0) {
        return children;
    }
    var Provider = providerValuePairs[0][0].Provider;
    return ((0, jsx_runtime_1.jsx)(Provider, { value: providerValuePairs[0][1], children: renderProviders(providerValuePairs.slice(1), children) }));
}
var ContextProvider = /** @class */ (function (_super) {
    __extends(ContextProvider, _super);
    function ContextProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContextProvider.prototype.render = function () {
        return renderProviders(this.props.contexts, this.props.children);
    };
    return ContextProvider;
}(React.Component));
exports.ContextProvider = ContextProvider;
function connectContextsToProps(propNamesToContexts) {
    return function (WrappedComponentType) {
        var connectedToContexts = (function (props) {
            var e_1, _a;
            var resolvedContextProps = {};
            try {
                for (var _b = __values(Object.entries(propNamesToContexts)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read(_c.value, 2), propName = _d[0], contextType = _d[1];
                    // eslint-disable-next-line react-hooks/rules-of-hooks -- runs synchronously and deterministically
                    resolvedContextProps[propName] = React.useContext(contextType);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return (0, jsx_runtime_1.jsx)(WrappedComponentType, __assign({}, resolvedContextProps, props));
        });
        connectedToContexts.displayName = (0, Hoc_1.createDisplayName)("ContextsToProps", WrappedComponentType);
        return connectedToContexts;
    };
}
//# sourceMappingURL=Ioc.js.map